import React, { useState, useEffect, useMemo } from "react";
import { Row, Col, Typography, message } from "antd";
import { useSelector, useDispatch } from "react-redux";

import Tickets from "../../../molecules/Tickets";
import AddTicket from "./components/AddTicket";
import ViewTicket from "./components/ViewTicket";
import AssignTechnician from "./components/AssignTechnician";
import ReAssignTechnician from "./components/ReAssignTechnician";

import { SectionHeaderV2 } from "../../../organism/SectionHeaderV2";
import { Popup } from "../../../atoms/Popup";
import DashboardLayout from "../../../molecules/DashboardLayout";
import { getPropertiesDrop } from "../../Properties/ducks/actions";
import { getPropertyUnits } from "../../Properties/PropertyDetail/ducks/actions";

import { getNewTicket, getInprogressTicket, getAcknowledgedTicket, getClosedTicket } from "./ducks/actions";
import { getTechniciansForServiceProviders } from "../Technicians/ducks/actions";

import moment from "moment";
import { useSearchParams } from "react-router-dom";
import ActivityLog from "./components/ViewTicket/activityLog";
import RejectTicket from "./components/ViewTicket/rejectTicket";
import ViewTenantDetail from "./components/ViewTicket/ViewTenantDetail";
import { getAllMaintenanceTypes } from "../../Configurations/ducks/actions";
import { getPropertyName } from "./ducks/actions";
import { getPresignedImage } from "../../../../utils/media";
import ExportTicket from "./components/ExportTicket";
import { useTicketsSearch } from "./hooks";
import { useFeatureFlags } from "../../../../feature-flags";

const dayjs = require("dayjs");

const { Title } = Typography;

interface TicketParams {
  technicianId?: string;
  startDate?: string;
  endDate?: string;
  categoryId?: string;
  search?: string;
  propertyId?: string;
  unitId?: string;
  subStatus?: string;
}

const categories = {
  value: "All",
  label: "All Categories",
};
const initialTechValue = {
  value: "All",
  label: "All Technicians",
};
const defaultNewStatusType = [
  {
    value: "All",
    label: "All New Tickets",
  },
  {
    value: "draft",
    label: "Draft",
  },
  {
    value: "initial_assessment",
    label: "Assigned For Initial Assessment",
  },
];
const defaultInProgressStatusType = [
  {
    value: "All",
    label: "All In Progress Tickets",
  },
  { value: "reached_barcode_scanned", label: "Reached - Bar Code Scanned" },
  {
    value: "inprogress_barcode_scanned",
    label: "In Progress - Bar Code Scanned",
  },
  { value: "ticket_type_changed", label: "Ticket Type Changed" },
  { value: "issue_not_resolved", label: "Issue Not Resolved" },
  { value: "technician_forwarded", label: "Forwarded To Technician" },
  { value: "reopen_closed", label: "Reopen" },
  { value: "pending_confirmation", label: "Pending Confirmation" },
  { value: "ticket_type_confirm", label: "Ticket Type Confirm" },
];
const defaultScheduledStatusType = [
  {
    value: "All",
    label: "All Scheduled Tickets",
  },
  { value: "acknowledged", label: "Acknowledged" },
];

const defaultCompletedStatusType = [
  { value: "All", label: "All Closed Tickets" },
  { value: "suspended", label: "Suspended" },
  { value: "closed", label: "Closed" },
  { value: "landlord_not_responsible", label: "Landlord not Responsible" },
  { value: "issue_resolved", label: "Issue Resolved" },
  { value: "reject", label: "Reject" },
];

export default (props) => {
  const dispatch: any = useDispatch();
  const currentDate = dayjs().format("YYYY-MM-DD");
  const mondayDate = dayjs().startOf("week").add(1, "day").format("YYYY-MM-DD");
  const sundayDate = dayjs().endOf("week").add(1, "day").format("YYYY-MM-DD");
  const [ticketNew, setTicketNew] = useState([]);
  const [ticketInProgress, setTicketInProgress] = useState([]);
  const [ticketAcknowledge, setTicketAcknowledge] = useState([]);
  const [ticketClosed, setTicketClosed] = useState([]);
  const [countNew, setCountNew] = useState(1);
  const [countProgress, setCountProgress] = useState(1);
  const [countAcknowledge, setCountAcknowledge] = useState(1);
  const [countClosed, setCountClosed] = useState(1);
  const [visible, setVisible] = useState(false);
  const [trigger, setTrigger] = useState(0);
  const [selectedTicket, setSelectedTickets] = useState();
  const [recurringTicket, setRecurringTicket] = useState();
  const [showClosedTickets, setShowClosedTickets] = useState(false);
  const [ticketsType, setTicketType] = useState([categories]);
  const [allTechnicians, setTechnicians] = useState([initialTechValue]);
  const [technicianId, setTechnicianId] = useState();
  const [selectedSearchBy, setSelectedSearchBy] = useState();
  const [searchValue, setSearchValue] = useState();
  const [newStatusType, setNewStatusType] = useState(defaultNewStatusType);
  const [progressStatusType, setProgressStatusType] = useState(defaultInProgressStatusType);
  const [scheduledStatusType, setScheduledStatusType] = useState(defaultScheduledStatusType);
  const [completedStatusType, setCompletedtatusType] = useState(defaultCompletedStatusType);
  const [newStatusTypeId, setNewStatusTypeId] = useState();
  const [closedStatusTypeId, setClosedStatusTypeId] = useState();
  const [progressStatusTypeId, setProgressStatusTypeId] = useState();
  const [timeRange, setTimeRange] = useState({
    startDate: mondayDate,
    endDate: sundayDate,
    key: "week",
  });
  const [activityLogTicketData, setActivityLogTicketData] = useState();
  const [rejectTicketData, setRejectTicketData] = useState();
  const [tenantDetailData, setTenantDetailData] = useState();
  const [parentTicket, setParentTicket] = useState(null);
  const [propertyId, setPropertyId] = useState("");
  const [unitId, setUnitID]: any = useState("");
  const [dates, setDates] = useState({ from_date: "", to_date: "" });
  const [searchParams, setSearchParams] = useSearchParams();
  const [unitLoading, setUnitLoading] = useState(false);
  const [updateValue, setUpdateValue] = useState({});
  const notifyCaseId = props?.location?.state?.identifier_value;

  const { selectOptions, handleSearch, handleChangeSearchBy, buildParams } = useTicketsSearch({
    selectedSearchBy,
    setSelectedSearchBy,
    setSearchValue,
  });

  const ticketsApiNew = useSelector((state: any) => state.tickets.ticketsDataNew);

  const ticketsApiProgress = useSelector((state: any) => state.tickets.ticketsDataProgress);
  const ticketsApiAcknowledge = useSelector((state: any) => state.tickets.ticketsDataAcknowledged);
  const ticketsApiClosed = useSelector((state: any) => state.tickets.ticketsDataClosed);
  const getTechnicians = useSelector((state: any) => state.technicians.techniciansList);

  const propertiesList = useSelector((state: any) => state.dashboard.propertiesDrop);

  const properties = useSelector((state: any) => state.tickets.propertyname);
  let units = useSelector((state: any) => state.propertyDetails.unitsDropdown);
  const usertype = JSON.parse(window.localStorage.getItem("login-response"))?.usertype;
  const defaultPropertyOpt = { label: "All Properties", value: "" };
  const defaultUnitOpt = {
    label: unitLoading ? "Loading..." : "All Units",
    value: "",
  };

  let allUnits = [];
  let allProperties = [];

  if (!usertype.includes("serviceProvider")) {
    allProperties = propertiesList ? propertiesList : [];
    allUnits = units ? units : [];
  } else {
    allUnits = units ? units : [];
    properties?.forEach((item) => {
      allProperties.push({
        value: item?.propertyId,
        label: item?.buildingName,
        buName: item?.businessUnitName,
      });
    });
  }

  const filterOptions = [
    {
      name: "property",
      label: "Property",
      search: true,
      initialValue: "",
      options: [defaultPropertyOpt, ...allProperties],
      unitLoading: false,
    },
    {
      name: "unit",
      label: "Unit",
      search: true,
      initialValue: "",
      options: [defaultUnitOpt, ...allUnits],
      unitLoading: unitLoading,
    },
    {
      name: `Technicians (${allTechnicians.length - 1})`,
      label: "Technicians",
      placeholder: "Select Technician",
      initialValue: "All",
      options: allTechnicians,
      search: true,
      unitLoading: false,
    },
    {
      name: `Date`,
      label: "Date",
      placeholder: "Select Date",
      initialValue: "week",
      options: [
        { value: "today", label: "Today" },
        { value: "week", label: "This week" },
        { value: "all", label: "All" },
      ],
      unitLoading: false,
    },
  ];

  const { isFeatureEnabled } = useFeatureFlags();

  const searchByOptions = useMemo(() => {
    return [
      {
        label: `Categories (${ticketsType.length - 1})`,
        options: ticketsType,
      },
      ...(isFeatureEnabled("13676-search-by-owner-bu")
        ? [
            {
              label: "Others",
              options: [
                { value: "businessUnitId", label: "Business Unit", controlType: "select" },
                { value: "ownerName", label: "Owner", controlType: "select" },
              ],
            },
          ]
        : []),
    ];
  }, [ticketsType]);

  const ticketTypeApi = useSelector((state: any) => state.configuration.allMaintenanceTypes);

  useEffect(() => {
    if (searchParams && searchParams.get("ticketid")) {
      let ds: any = { ticketId: searchParams.get("ticketid") };
      setSelectedTickets(ds);
      setTrigger(1);
      setVisible(true);
    }

    if (!usertype.includes("serviceProvider")) {
      dispatch(getPropertiesDrop());
    } else {
      dispatch(getPropertyName());
    }
  }, [searchParams]);

  const callingApi = async () => {
    // Reset states
    setTicketNew([]);
    setTicketInProgress([]);
    setTicketAcknowledge([]);
    setTicketClosed([]);
    setCountClosed(1);
    setCountProgress(1);
    setCountAcknowledge(1);
    setCountNew(1);

    const param = buildParams({
      technicianId,
      timeRange,
      selectedSearchBy,
      searchValue,
      propertyId,
      unitId,
    });

    // Helper function to dispatch ticket requests
    const dispatchTicketRequest = (
      dispatchFunction: (page: number, params: TicketParams) => void,
      statusTypeId?: string,
      page: number = 1,
    ) => {
      const requestParams: TicketParams = statusTypeId ? { ...param, subStatus: statusTypeId } : param;
      dispatch(dispatchFunction(page, requestParams));
    };

    dispatchTicketRequest(getNewTicket, newStatusTypeId, 1);
    dispatchTicketRequest(getInprogressTicket, progressStatusTypeId, 1);
    dispatch(getAcknowledgedTicket(1, param));
    if (showClosedTickets) {
      dispatchTicketRequest(getClosedTicket, closedStatusTypeId, 1);
    }
  };

  const callingClosedApi = async () => {
    setTicketClosed([]);
    setCountClosed(1);

    const param = buildParams({
      technicianId,
      timeRange,
      selectedSearchBy,
      searchValue,
      propertyId,
      unitId,
    });

    if (closedStatusTypeId) {
      dispatch(
        getClosedTicket(1, {
          ...param,
          ...{ subStatus: closedStatusTypeId },
        }),
      );
    } else {
      dispatch(getClosedTicket(1, param));
    }
  };

  useEffect(() => {
    callingApi();
  }, [technicianId, selectedSearchBy, searchValue, timeRange, propertyId, unitId]);

  useEffect(() => {
    dispatch(getPropertyUnits(false, false, true, setUnitLoading));
    ticketTypeApi?.length === 0 && dispatch(getAllMaintenanceTypes());
    dispatch(getTechniciansForServiceProviders());
  }, []);

  function removeDuplicates(array, property) {
    const seen = new Set();
    return array.filter((item) => {
      const value = item[property];
      if (seen.has(value)) {
        return false;
      }
      seen.add(value);
      return true;
    });
  }

  useEffect(() => {
    let data =
      ticketTypeApi?.residential
        ?.map((item) => ({
          value: item.categoryId,
          label: item.name,
        }))
        ?.filter((item) => item?.value && item?.label) || [];

    data.unshift(categories);
    data = removeDuplicates(data, "value");
    setTicketType(data);
  }, [ticketTypeApi]);

  useEffect(() => {
    let data = getTechnicians;
    data?.unshift(initialTechValue);

    setTechnicians(data);
  }, [getTechnicians]);

  const onSubmit = () => {
    callingApi();
    setVisible(false);
  };

  useEffect(() => {
    const updateTickets = (apiData, existingTickets, setTickets) => {
      if (!apiData) return;

      let tempArr = [];

      if (apiData.currentPage > 1) {
        tempArr = [...existingTickets, ...apiData.data];
      } else {
        tempArr = apiData.data;
      }

      tempArr = tempArr.filter((value, index, self) => index === self.findIndex((t) => t._id === value._id));

      setTickets(tempArr);
    };

    updateTickets(ticketsApiNew, ticketNew, setTicketNew);
    updateTickets(ticketsApiProgress, ticketInProgress, setTicketInProgress);
    updateTickets(ticketsApiAcknowledge, ticketAcknowledge, setTicketAcknowledge);
    updateTickets(ticketsApiClosed, ticketClosed, setTicketClosed);
  }, [ticketsApiNew, ticketsApiProgress, ticketsApiAcknowledge, ticketsApiClosed]);

  const countUpdate = async (param) => {
    let parami = buildParams({
      technicianId,
      selectedSearchBy,
      searchValue,
      propertyId,
      unitId,
      categoryKey: "caseCategoryName",
    });
    if (param === "new") {
      if (newStatusTypeId) {
        parami["subStatus"] = newStatusTypeId;
      }
      setCountNew(countNew + 1);
      dispatch(getNewTicket(countNew + 1, parami));
    } else if (param === "progress") {
      if (progressStatusTypeId) {
        parami["subStatus"] = progressStatusTypeId;
      }
      setCountProgress(countProgress + 1);
      dispatch(getInprogressTicket(countProgress + 1, parami));
    } else if (param === "acknowledge") {
      setCountAcknowledge(countAcknowledge + 1);
      dispatch(getAcknowledgedTicket(countAcknowledge + 1, parami));
    } else if (param === "closed") {
      if (closedStatusTypeId) {
        parami["subStatus"] = closedStatusTypeId;
      }
      setCountClosed(countClosed + 1);
      dispatch(getClosedTicket(countClosed + 1, parami));
    }
  };

  const popup = [
    {
      closable: true,
      title: (
        <Title level={3} className="mb-0">
          Add Maintenance Requests
        </Title>
      ),
      content: (
        <AddTicket
          parentTicket={parentTicket}
          onSubmit={() => onSubmit()}
          onCancel={() => setVisible(false)}
          setParentTicketId={setParentTicket}
        />
      ),
      width: 680,
    },
    {
      title: null,
      content: (
        <ViewTicket
          data={selectedTicket}
          onRecurring={(e) => originalTicket(e)}
          onActivityLog={(e) => activityLogTicket(e)}
          onRejectTicket={(e) => rejectTicketTicket(e)}
          onviewTenantDetails={(e) => viewTeanantDetail(e)}
          onCancel={() => setVisible(false)}
          assignTech={assignTechnician}
          onSubmit={onSubmit}
        />
      ),
      width: "62rem",
    },
    {
      title: (
        <Title level={3} className="ag-primary mb-0">
          Assign Technician
        </Title>
      ),
      content: <AssignTechnician ticket={selectedTicket} onBack={() => setTrigger(1)} onAssign={onAssign} />,
      width: 650,
    },
    {
      title: null,
      content: (
        <ViewTicket
          data={recurringTicket}
          onActivityLog={(e) => activityLogTicket(e)}
          onviewTenantDetails={(e) => viewTeanantDetail(e)}
          onBack={() => {
            setTrigger(1);
            setRecurringTicket(null);
          }}
          onCancel={() => setVisible(false)}
          assignTech={assignTechnician}
          onSubmitTicket={onSubmit}
        />
      ),
      width: 920,
    },
    {
      title: null,
      content: (
        <ActivityLog
          data={activityLogTicketData}
          onBack={() => {
            if (recurringTicket) {
              setTrigger(3);
            } else {
              setTrigger(1);
            }
            setActivityLogTicketData(null);
          }}
          onCancel={() => setVisible(false)}
        />
      ),
      width: 920,
    },
    {
      title: null,
      content: (
        <RejectTicket
          data={rejectTicketData}
          onBack={() => {
            setTrigger(1);
            setRejectTicketData(null);
          }}
          onCancel={() => setVisible(false)}
        />
      ),
      width: 920,
    },
    {
      title: null,
      content: (
        <ViewTenantDetail
          data={tenantDetailData}
          onBack={() => {
            if (recurringTicket) {
              setTrigger(3);
            } else {
              setTrigger(1);
            }
            setTenantDetailData(null);
          }}
          onCancel={() => setVisible(false)}
        />
      ),
      width: 920,
    },
    {
      title: (
        <Title level={3} className="m-0">
          Modify Maintenance Requests
        </Title>
      ),
      content: (
        <ReAssignTechnician
          ticket={selectedTicket}
          onBack={() => setVisible(false)}
          onAssign={onAssign}
          onSubmit={onSubmit}
        />
      ),
      width: 650,
    },
    {
      title: (
        <Title level={3} className="m-0">
          Export Maintenance Requests
        </Title>
      ),
      content: <ExportTicket onSubmit={() => onSubmit()} onCancel={() => setVisible(false)} />,
      width: 650,
    },
  ];

  const popupProps = {
    closable: trigger == 0 ? true : false,
    visibility: visible,
    title: popup[trigger].title,
    content: popup[trigger].content,
    width: popup[trigger].width,
    style: { padding: "1.5rem" },
    onCancel: () => setVisible(false),
  };

  const handleNewStatusChange = async (value) => {
    setTicketNew([]);
    const param = buildParams({
      technicianId,
      timeRange,
      selectedSearchBy,
      searchValue,
      propertyId,
      unitId,
      categoryKey: "caseCategoryName",
    });

    if (value !== "All") {
      param["subStatus"] = value;
    }
    setCountNew(1);
    setNewStatusTypeId(value !== "All" ? value : null);
    dispatch(getNewTicket(1, param));
  };

  const handleProgressStatusChange = async (value) => {
    setTicketInProgress([]);

    const param = buildParams({
      technicianId,
      timeRange,
      selectedSearchBy,
      searchValue,
      propertyId,
      unitId,
      categoryKey: "caseCategoryName",
    });

    if (value !== "All") {
      param["subStatus"] = value;
    }
    setCountProgress(1);
    setProgressStatusTypeId(value !== "All" ? value : null);
    dispatch(getInprogressTicket(1, param));
  };

  const handleScheduledStatusChange = async (value) => {
    setTicketAcknowledge([]);

    const param = buildParams({
      technicianId,
      timeRange,
      selectedSearchBy,
      searchValue,
      propertyId,
      unitId,
      categoryKey: "caseCategoryName",
    });

    setCountAcknowledge(1);
    dispatch(getAcknowledgedTicket(1, param));
  };

  const handleCompletedStatusChange = async (value) => {
    setTicketClosed([]);

    const param = buildParams({
      technicianId,
      timeRange,
      selectedSearchBy,
      searchValue,
      propertyId,
      unitId,
      categoryKey: "caseCategoryName",
    });

    if (value !== "All") {
      param["subStatus"] = value;
    }
    setCountClosed(1);
    setClosedStatusTypeId(value !== "All" ? value : null);
    dispatch(getClosedTicket(1, param));
  };

  function assignTechnician() {
    setTrigger(2);
  }

  function originalTicket(ticket) {
    callImages(ticket, true);
  }
  function activityLogTicket(ticket) {
    callImages(ticket, "activity");
  }

  function rejectTicketTicket(ticket) {
    callImages(ticket, "rejectTicket");
  }

  function viewTeanantDetail(ticket) {
    callImages(ticket, "tenantDetail");
  }

  function onAssign() {
    setTrigger(1);
  }

  const onClickExport = async () => {
    alert("export clicked");
  };

  function addTicket() {
    setVisible(true);
    setTrigger(0);
    setParentTicket({});
  }

  function downloadAction() {
    setTrigger(8);
    setVisible(true);
  }

  const getMedia = async (totalImages) => {
    if (totalImages?.length > 0) {
      const result = await getPresignedImage(totalImages); //change
      if (result && result.length > 0) {
      } else {
        message.error("Something wrong with Media");
      }
      return result;
    }
    return [];
  };

  const callImages = async (item, recuring, type = "") => {
    if (recuring !== "activity" && recuring !== "rejectTicket" && recuring !== "tenantDetail") {
      let totalImages = [];
      let totalVideos = [];
      if (item.documents && item.documents.length > 0) {
        item.documents.map((x) => {
          if (x?.documentId && !x?.type.includes("mp4")) {
            totalImages.push(x.documentId);
          } else {
            totalVideos.push(x.documentId);
          }
        });
        const images = await getMedia(totalImages);
        const videos = await getMedia(totalVideos);
        item.totalImageURL = images;
        item.totalVideoUrls = videos;
      }

      let techtotalImages = [];
      let techtotalVideos = [];
      if (item?.technicianDocuments && item?.technicianDocuments?.length > 0) {
        item.technicianDocuments.map((x) => {
          if (x?.documentId && !x?.type.includes("mp4")) {
            techtotalImages.push(x.documentId);
          } else {
            techtotalVideos.push(x.documentId);
          }
        });
        const images = await getMedia(techtotalImages);
        const videos = await getMedia(techtotalVideos);
        item.techtotalImageURL = images;
        item.techtotalVideoUrls = videos;
      }
    }
    if (recuring && recuring !== "activity" && recuring !== "rejectTicket" && recuring !== "tenantDetail") {
      setRecurringTicket({ ...item, ...{ ticketStatus: type } });
      setTrigger(3);
    } else if (recuring == "activity") {
      setActivityLogTicketData({ ...item, ...{ ticketStatus: type } });
      setTrigger(4);
    } else if (recuring == "rejectTicket") {
      setRejectTicketData({ ...item, ...{ ticketStatus: type } });
      setTrigger(5);
    } else if (recuring == "tenantDetail") {
      setTenantDetailData({ ...item, ...{ ticketStatus: type } });
      setTrigger(6);
    } else {
      setTrigger(1);
      setVisible(true);
      setSelectedTickets({ ...item, ...{ ticketStatus: type } });
    }
  };

  async function viewTicket(item, type = "") {
    callImages(item, false, type);
  }

  const onStartDate = (e) => {
    setDates({
      from_date: moment(e).format("YYYY-MM-DD"),
      to_date: "",
    });
  };
  const onEndDate = (e) => {
    setDates({ ...dates, to_date: moment(e, "YYYY-").format("YYYY-MM-DD") });
  };

  const assignDateRange = (key) => {
    switch (key) {
      case "today":
        setTimeRange({
          startDate: currentDate,
          endDate: currentDate,
          key: key,
        });
        break;
      case "week":
        setTimeRange({ startDate: mondayDate, endDate: sundayDate, key: key });
        break;

      default:
        setTimeRange({ startDate: null, endDate: null, key: key });
        break;
    }
  };

  const searchTrigger = (e) => {
    if (e?.key === "today" || e?.key === "week" || e?.key === "all") {
      assignDateRange(e?.key);
    } else if (e?.value.includes("propertyId") || e?.value === "") {
      if (propertyId && e?.label?.includes("Units") && e.value === "") {
        setPropertyId(propertyId);
      } else {
        setUpdateValue([{ label: "unit", value: "" }]);
        setPropertyId(e?.value);
      }
      setUnitID(null);
      dispatch(getPropertyUnits(e?.value === "" ? false : e?.value, false, true, setUnitLoading));
    } else if (e?.value.includes("unitId") || e?.value === "") {
      setUnitID(e?.value);
    } else {
      setTechnicianId(e?.value);
    }
  };

  const handleClickAction = (item, e) => {
    if (e !== "select") {
      setTrigger(7);
      setVisible(true);
      setSelectedTickets({ ...item, ...{ ticketStatus: e } });
    }
  };

  return (
    <>
      <DashboardLayout>
        <Row gutter={24}>
          <Col span={24}>
            <SectionHeaderV2
              heading="Maintenance Requests"
              noBorder={true}
              total={
                (ticketsApiNew?.totalCount || 0) +
                (ticketsApiProgress?.totalCount || 0) +
                (ticketsApiClosed?.totalCount || 0) +
                (ticketsApiAcknowledge?.totalCount || 0)
              }
              updateValue={updateValue}
              downloadAction={downloadAction}
              addNewAction={addTicket}
              onSearch={handleSearch}
              onChangeSearchBy={handleChangeSearchBy}
              defaultSearch={searchValue}
              searchByOptions={searchByOptions}
              selectOptions={selectOptions}
              viewOption={filterOptions}
              justifiedItems={true}
              justifyEnd={true}
              handleView={searchTrigger}
              onStart={onStartDate}
              onEnd={onEndDate}
              dates={dates}
              onChange={(e) => {
                searchTrigger(e);
              }}
              exportAction2={onClickExport}
            />
            <Row gutter={24} style={{ marginTop: "13px" }}>
              <Col xl={24} lg={24}>
                <Row gutter={24}>
                  <Col span={6}>
                    <Tickets
                      ticketlist={ticketNew && ticketNew?.length > 0 ? ticketNew : []}
                      category="New"
                      count={ticketsApiNew?.totalCount || 0}
                      onCount={() => countUpdate("new")}
                      viewTicket={(e) => viewTicket(e, "new")}
                      clickDropDown={(item, e) => handleClickAction(item, e)}
                      showStatusOption={newStatusType}
                      handleStatusChange={handleNewStatusChange}
                      notifyCaseId={notifyCaseId}
                    />
                  </Col>

                  <Col span={6}>
                    <Tickets
                      ticketlist={ticketAcknowledge && ticketAcknowledge.length > 0 ? ticketAcknowledge : []}
                      count={ticketsApiAcknowledge?.totalCount || 0}
                      onCount={() => countUpdate("acknowledge")}
                      category="Scheduled"
                      viewTicket={(e) => viewTicket(e, "acknowledge")}
                      clickDropDown={(item, e) => handleClickAction(item, e)}
                      showStatusOption={scheduledStatusType}
                      handleStatusChange={handleScheduledStatusChange}
                      notifyCaseId={notifyCaseId}
                    />
                  </Col>
                  <Col span={6}>
                    <Tickets
                      setVisible={setVisible}
                      setParentTicketId={setParentTicket}
                      setTrigger={setTrigger}
                      ticketlist={ticketInProgress && ticketInProgress.length > 0 ? ticketInProgress : []}
                      count={ticketsApiProgress?.totalCount || 0}
                      onCount={() => countUpdate("progress")}
                      category="In Progress"
                      viewTicket={(e) => viewTicket(e, "progress")}
                      clickDropDown={(item, e) => handleClickAction(item, e)}
                      showStatusOption={progressStatusType}
                      handleStatusChange={handleProgressStatusChange}
                      notifyCaseId={notifyCaseId}
                    />
                  </Col>
                  <Col span={6}>
                    <Tickets
                      setVisible={setVisible}
                      setParentTicketId={setParentTicket}
                      setTrigger={setTrigger}
                      ticketlist={ticketClosed && ticketClosed.length > 0 ? ticketClosed : []}
                      count={ticketsApiClosed?.totalCount || 0}
                      onCount={() => countUpdate("closed")}
                      category="Closed"
                      viewTicket={(e) => viewTicket(e, "closed")}
                      clickDropDown={(item, e) => handleClickAction(item, e)}
                      showStatusOption={completedStatusType}
                      handleStatusChange={handleCompletedStatusChange}
                      notifyCaseId={notifyCaseId}
                      showClosedTickets={showClosedTickets}
                      setShowClosedTickets={() => {
                        setShowClosedTickets(!showClosedTickets);
                        callingClosedApi();
                      }}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </DashboardLayout>
      <Popup destroyOnClose={true} {...popupProps} />
    </>
  );
};
